// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__s4N3W","bar":"Loader_bar__eMoWi","scale-up4":"Loader_scale-up4__7d5ao"};